// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.TermsOfService-riderBlog-eC8Ap{
  margin-bottom: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/static/termsOfService/TermsOfService.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB","sourcesContent":["\n.riderBlog{\n  margin-bottom: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"riderBlog": `TermsOfService-riderBlog-eC8Ap`
};
module.exports = ___CSS_LOADER_EXPORT___;
